import SiteLayout from "@/components/SiteLayout";
import PageMeta from "@/components/PageMeta";
import Hero from "@/components/sections/Hero";
import ExpertiseSection from "@/components/sections/ExpertiseSection";
import FeaturedLawyers from "@/components/sections/FeaturedLawyers";
import WhyCEC from "@/components/sections/WhyCEC";
import LatestInsights from "@/components/sections/LatestInsights";
import ContactSection from "@/components/sections/ContactSection";

export default function Home() {
  return (
    <SiteLayout>
      <PageMeta
        title="Carlton Elleker Chase | A modern London law firm"
        description="Considered counsel for corporates, founders, funds and private clients across six core departments — Company & Commercial, Disputes, Financial Services, IP, Technology & Media and Real Estate."
        image="/brand/cec-logo.png"
      />
      <Hero />
      <ExpertiseSection />
      <FeaturedLawyers />
      <WhyCEC />
      <LatestInsights />
      <ContactSection compact />
    </SiteLayout>
  );
}
